import {getCurrentUser} from 'New/serverRequests/requests';
import React, {useEffect} from 'react';

const navigateToLoginPage = () => {
  const url = window.location.origin + '/login';
  window.location.href = url;
};

const withAuth = (Component) => {
  const AuthenticatedComponent = ({...props}) => {
    useEffect(() => {
      const getUser = async () => {
        const userData = await getCurrentUser();
        if (!userData?.userid && userData?.userid !== 42) {
          navigateToLoginPage();
        }
      };
      const pollUserInterval = setInterval(() => getUser(), 5000);
      return () => clearInterval(pollUserInterval);
    }, []);

    return <Component {...props} />;
  };

  return AuthenticatedComponent;
};

export default withAuth;
export {navigateToLoginPage};
